// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"97":"4527047b","167":"6ef75279","177":"a1527e2d","389":"36a79034","457":"0fb1469b","659":"97387f70","734":"770901fa","867":"b7dc86f8","974":"cc14463c"}[chunkId] + ".css";
};